const FETCH_COUNT_LIMIT = 100;

/**
 * A generic function to fetch all entries using pagination.
 * It's a workaround for limit of 100 entries per request in Builder.io API.
 * Or sometimes less. As many as does not break builder.io API.
 * How many is that? Who knows. For articles it's 10.
 */
export async function getAllEntries<T>(fetchPart: FetchPartFn<T>, limit: number = FETCH_COUNT_LIMIT) {
  const result: T[] = [];

  let offset = 0;
  let fetchedCount = limit;

  while (fetchedCount === limit) {
    const { items, totalFetched } = await fetchPart({
      limit,
      offset,
    });

    result.push(...items);

    fetchedCount = totalFetched;
    offset += totalFetched;
  }

  return result;
}

export type FetchPartFn<T> = (variables: {
  limit: number;
  offset: number;
}) => Promise<{ items: T[]; totalFetched: number }>;
